"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionController = void 0;
var netcheck_1 = require("@tencent/netcheck");
var types_1 = require("@tencent/ark-utils/lib/types");
var event_1 = require("@tencent/ark-utils/lib/event");
var big_data_channel_1 = require("../channel/big-data-channel");
var util_1 = require("../util");
var interface_1 = require("../interface");
var connection_controller_interface_1 = require("./connection-controller.interface");
var websocket_channel_1 = require("../websocket-channel");
var common_request_channel_1 = require("../channel/common-request-channel");
var big_collab_1 = require("../channel/big-collab");
var feature_1 = require("../feature");
// 超过WS限制大小，切换通道发送
var defaultWebsocketMaxContentLimitLength = 5 * 1024 * 1024;
/**
 * 连接层控制器，业务需要创建实例
 *
 * @class ConnectionController
 * @implements {IConnectionController}
 */
var ConnectionController = /** @class */ (function () {
    function ConnectionController(options) {
        var _this = this;
        var _a;
        this.onConnectionEventEmitter = new event_1.Emitter();
        this.middleWareCenter = new feature_1.MiddleWareCenter();
        /**
         * 转发事件
         *
         * @private
         * @param {ConnectionCallBackEvent} event
         * @param {*} [data]
         */
        this.connectionFireEvent = function (event, data) {
            _this.onConnectionEventEmitter.fire({ event: event, data: data });
        };
        this.options = options;
        this.setConnectMode(((_a = this.options.config) === null || _a === void 0 ? void 0 : _a.connectMode) || connection_controller_interface_1.ConnectMode.WEBSOCKET);
        this.onConnectionEvent = this.onConnectionEventEmitter.event;
        this.initDependencyEvent();
    }
    /**
     * 主动销毁
     *
     */
    ConnectionController.prototype.dispose = function () {
        this.onConnectionEventEmitter.dispose();
        this.destoryChannel();
    };
    ConnectionController.prototype.useMiddleWare = function (type, middleWare) {
        this.middleWareCenter.useMiddleWare(type, middleWare);
    };
    ConnectionController.prototype.connect = function (mode) {
        if (mode === void 0) { mode = connection_controller_interface_1.ConnectMode.WEBSOCKET; }
        util_1.ConnectionLog.info("connect mode:" + mode);
        this.setConnectMode(mode);
        this.connectChannel(mode);
    };
    /**
     * 即将废弃
     * @deprecated
     */
    ConnectionController.prototype.reConnect = function (options, mode) {
        if (mode === void 0) { mode = connection_controller_interface_1.ConnectMode.WEBSOCKET; }
        this.reconnect(options, mode);
    };
    ConnectionController.prototype.reconnect = function (options, mode) {
        if (mode === void 0) { mode = connection_controller_interface_1.ConnectMode.WEBSOCKET; }
        util_1.ConnectionLog.warn("reconnect mode:" + mode);
        if (options) {
            this.options = options;
        }
        this.destoryChannel();
        this.setConnectMode(mode);
        this.connectChannel(mode);
    };
    /**
     * @deprecated
     */
    ConnectionController.prototype.isConnecting = function () {
        return this.isConnected();
    };
    ConnectionController.prototype.isConnected = function () {
        return this.isWebsocketRoomState(websocket_channel_1.RoomState.OPENED)
            || (this.isUseBigCollabChannel() && this.bigCollabChannel.isConnected());
    };
    /**
     * @deprecated
     */
    ConnectionController.prototype.isDisconnect = function () {
        return this.isDisconnected();
    };
    /**
     * 是否关闭状态（不会继续重连）
     *
     * @returns {boolean}
     */
    ConnectionController.prototype.isDisconnected = function () {
        return this.isWebsocketRoomState(websocket_channel_1.RoomState.SHUTDOWN)
            || (this.isUseBigCollabChannel() && this.bigCollabChannel.isDisconnected());
    };
    /**
     * 断开连接，不在重试。用于发生异常时停止协同。
     *
     * @param {IDisconnectReason} reason
     */
    ConnectionController.prototype.disconnect = function (reason) {
        var _a, _b;
        if (this.isDisconnected()) {
            util_1.ConnectionLog.warn("was disconnect, please do not disconnect. new errCode:" + reason.errCode);
            return;
        }
        this.isUseBigCollabChannel() ? (_a = this.bigCollabChannelInstance) === null || _a === void 0 ? void 0 : _a.disconnect(reason) : (_b = this.websocketChannelInstance) === null || _b === void 0 ? void 0 : _b.disconnect(reason);
    };
    /**
     * 网络探测结果是否为在线
     *
     * @returns
     * @memberof ConnectionController
     */
    ConnectionController.prototype.isOnline = function () {
        return netcheck_1.network.isOnline;
    };
    /**
     * 业务需要主动更新版本
     *
     * @param {number} version
     */
    ConnectionController.prototype.setVersion = function (version) {
        if (types_1.isNumber(version)) {
            this.version = version;
            return;
        }
        util_1.ConnectionLog.error('setVersion version is not number');
    };
    /**
     * 单个发送
     * 内容过大时切换到Http通道
     * @param {IRoomSendMessagePacket} sendMessage
     * @returns {*}
     * @memberof ConnectionController
     */
    ConnectionController.prototype.sendMessage = function (message) {
        if (util_1.isInvalidMessage(message)) {
            util_1.ConnectionLog.warn('sendMessage fail: params invalid!');
            message.onError(message.taskId, message.cmd, message.data, {
                errCode: websocket_channel_1.RoomErrorCode.PARA_ERROR,
                errMsg: 'msg param invalid.',
            });
            return;
        }
        this.configMessageParam(message);
        if (this.isUseBigDataChannel(message)) {
            this.bigDataChannel.sendMessage(message);
        }
        else if (this.isUseBigCollabChannel()) {
            this.bigCollabChannel.sendMessage(message);
        }
        else {
            this.websocketChannel.sendMessage(message);
        }
    };
    /**
     * 透传消息
     * @param message
     */
    ConnectionController.prototype.sendCommonRequest = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commonRequestChannel.sendMessage(message)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * 批量发送
     *
     * @param {IUserChange[]} messages
     * @memberof ConnectionController
     */
    ConnectionController.prototype.batchCommitMessages = function (messages, curVersion, otherOption) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!(messages === null || messages === void 0 ? void 0 : messages.length)) {
                    return [2 /*return*/, this.handleMessagesError()];
                }
                return [2 /*return*/, this.bigDataChannel.batchCommitMessages(messages, curVersion, otherOption)];
            });
        });
    };
    ConnectionController.prototype.cancelMessageBySeq = function (taskId) {
        this.cancelSendMessageByTaskId(taskId);
    };
    ConnectionController.prototype.cancelSendMessageByTaskId = function (taskId) {
        var _a, _b, _c, _d;
        (_b = (_a = this.websocketChannelInstance) === null || _a === void 0 ? void 0 : _a.cancelSendMessageByTaskId) === null || _b === void 0 ? void 0 : _b.call(_a, taskId);
        (_d = (_c = this.bigCollabChannelInstance) === null || _c === void 0 ? void 0 : _c.cancelSendMessageByTaskId) === null || _d === void 0 ? void 0 : _d.call(_c, taskId);
    };
    ConnectionController.prototype.handleMessagesError = function () {
        var reason = 'batchCommitMessages message is null!';
        util_1.ConnectionLog.warn(reason);
        var result = {
            success: false,
            retCode: 52001 /* PARAMETER_WRONG */,
            reason: reason,
        };
        return result;
    };
    Object.defineProperty(ConnectionController.prototype, "bigDataChannel", {
        get: function () {
            if (!this.bigDataChannelInstance) {
                this.bigDataChannelInstance = big_data_channel_1.BuildBigDataChannel(this.options, this.dependency);
            }
            return this.bigDataChannelInstance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionController.prototype, "bigCollabChannel", {
        get: function () {
            if (!this.bigCollabChannelInstance) {
                this.bigCollabChannelInstance = big_collab_1.BuildBigCollabChannel(this.options, this.dependency);
            }
            return this.bigCollabChannelInstance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionController.prototype, "websocketChannel", {
        get: function () {
            if (!this.websocketChannelInstance) {
                this.websocketChannelInstance = websocket_channel_1.BuildRoomWebsocketChannel(this.options, this.dependency, this.middleWareCenter);
            }
            return this.websocketChannelInstance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConnectionController.prototype, "commonRequestChannel", {
        get: function () {
            if (!this.commonRequestChannelInstance) {
                this.commonRequestChannelInstance = common_request_channel_1.buildCommonRequestChannel(this.options);
            }
            return this.commonRequestChannelInstance;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 是否使用大协同通道
     *
     * @private
     * @returns {boolean}
     */
    ConnectionController.prototype.isUseBigCollabChannel = function () {
        var _a;
        return ((_a = this.options.config) === null || _a === void 0 ? void 0 : _a.connectMode) === connection_controller_interface_1.ConnectMode.BIG_COLLAB;
    };
    /**
     * 是否使用Http通道
     *
     * @private
     * @param {IRoomSendMessagePacket} sendMessage
     * @returns {boolean}
     */
    ConnectionController.prototype.isUseBigDataChannel = function (sendMessage) {
        var _a;
        var bigDataCommitConfig = (_a = this.options.config) === null || _a === void 0 ? void 0 : _a.bigDataCommitConfig;
        if (sendMessage.cmd === "USER_CHANGES" /* USER_CHANGES */ && (bigDataCommitConfig === null || bigDataCommitConfig === void 0 ? void 0 : bigDataCommitConfig.isSupportBigDataCommit) === true) {
            // 数据长度超过限制，切换到大数据通道
            var dataLength = interface_1.getMessageDataLength(sendMessage.data);
            if (dataLength > ((bigDataCommitConfig === null || bigDataCommitConfig === void 0 ? void 0 : bigDataCommitConfig.minContentLength) || defaultWebsocketMaxContentLimitLength)) {
                util_1.ConnectionLog.info("sendMessage BigData, length:" + dataLength);
                return true;
            }
        }
        return false;
    };
    /**
     * 连接层对外部的cb转为事件通信
     *
     * @private
     */
    ConnectionController.prototype.initDependencyEvent = function () {
        var _this = this;
        this.dependency = {
            connected: function () {
                _this.connectionFireEvent("OnRoomOpen" /* onRoomOpen */);
                _this.connectionFireEvent("OnEnterOnline" /* onEnterOnline */);
            },
            connectedStateChange: function (roomState, description) {
                _this.connectionFireEvent("OnRoomStateChange" /* onRoomStateChange */, { roomState: { roomState: roomState, description: description } });
            },
            receiveMessageFromServer: function (type, data) {
                _this.connectionFireEvent("OnReceiveMsgFromServer" /* onReceiveMsgFromServer */, { serverMsg: { type: type, data: data } });
            },
            networkReconnectedFail: function () {
                _this.connectionFireEvent("OnNetReconnectedFail" /* onNetReconnectedFail */);
            },
            getHeaderGeneralPacket: function () { var _a, _b; return (_b = (_a = _this.options.config) === null || _a === void 0 ? void 0 : _a.headerGeneralPacket) !== null && _b !== void 0 ? _b : {}; },
            getVersion: function () { return _this.version; },
            disconnect: function (reason) {
                if (reason.shutDown) {
                    _this.connectionFireEvent("OnRoomShutDown" /* onRoomShutDown */, { closeReason: reason });
                }
                else {
                    _this.connectionFireEvent("OnRoomClose" /* onRoomClose */, { closeReason: reason });
                    _this.connectionFireEvent("OnEnterOffline" /* onEnterOffline */);
                }
            },
            heartBeatCommon: function (heartBeatCommon) {
                _this.connectionFireEvent("onHeartBeatCommon" /* onHeartBeatCommon */, { heartBeatCommon: heartBeatCommon });
            },
        };
    };
    /**
     *  检查房间状态
     *
     * @private
     * @param {RoomState} roomState
     * @returns {boolean}
     */
    ConnectionController.prototype.isWebsocketRoomState = function (roomState) {
        if (!this.websocketChannelInstance)
            return false;
        return this.websocketChannel.getRoomState() === roomState;
    };
    ConnectionController.prototype.connectChannel = function (mode) {
        if (mode === connection_controller_interface_1.ConnectMode.BIG_COLLAB) {
            this.bigCollabChannel.connect();
            return;
        }
        this.websocketChannel.connect();
    };
    ConnectionController.prototype.destoryChannel = function () {
        var _a, _b, _c, _d;
        (_a = this.websocketChannelInstance) === null || _a === void 0 ? void 0 : _a.dispose();
        this.websocketChannelInstance = undefined;
        (_b = this.bigDataChannelInstance) === null || _b === void 0 ? void 0 : _b.dispose();
        this.bigDataChannelInstance = undefined;
        (_c = this.commonRequestChannelInstance) === null || _c === void 0 ? void 0 : _c.dispose();
        this.commonRequestChannelInstance = undefined;
        (_d = this.bigCollabChannelInstance) === null || _d === void 0 ? void 0 : _d.dispose();
        this.bigCollabChannelInstance = undefined;
    };
    ConnectionController.prototype.setConnectMode = function (mode) {
        if (this.options.config) {
            this.options.config.connectMode = mode;
        }
        else {
            this.options.config = {
                connectMode: mode,
            };
        }
    };
    ConnectionController.prototype.configMessageParam = function (message) {
        var _a, _b;
        // 配置缺省参数
        if (!message.customParam) {
            message.customParam = {
                timeout: interface_1.DEFAULT_SEND_MESSAGE_TIMEOUT,
                maxRetryCount: interface_1.DEFAULT_RETRY_COUNTS,
            };
        }
        else {
            // 对业务配置参数对上限检查，最大超时时间不超过30秒
            if ((_a = message.customParam) === null || _a === void 0 ? void 0 : _a.timeout) {
                message.customParam.timeout = Math.min(message.customParam.timeout, 30000);
            }
            // 对业务配置参数对上限检查，最大重试次数不大于3次
            if ((_b = message.customParam) === null || _b === void 0 ? void 0 : _b.maxRetryCount) {
                message.customParam.maxRetryCount = Math.min(message.customParam.maxRetryCount, interface_1.DEFAULT_RETRY_COUNTS);
            }
        }
    };
    return ConnectionController;
}());
exports.ConnectionController = ConnectionController;
